var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import axios from 'axios';
import { notification } from 'antd';
import { HashRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { errorStore } from './utils/ErrorStore';
import LoginScreen from './screens/LoginScreen';
import TaskSelectScreen from './screens/TaskSelectScreen';
import PickMultisScreen from './screens/PickMultisScreen';
import PickSingleScreen from './screens/SinglePickScreen';
import MoveToSortingScreen from './screens/MoveToSortingScreen';
import SortingScreen from './screens/SortingScreen';
import ReceivingScreen from './screens/ReceivingScreen';
import MoveAssetScreen from './screens/MoveAssetScreen';
import SettingScreen from './screens/SettingScreen';
import PickRunsScreen from './screens/PickRunsScreen';
import i18n from './i18n';
import PickByShipmentScreen from './screens/PickByShipment';
import PackingScreen from './screens/PackingScreen';
import ReturnScreen from './screens/ReturnScreen';
import PutAwayScreen from './screens/PutAwayScreen';
import { useDispatch, useSelector } from 'react-redux';
import { getPrefferedLanguage, userSelector } from './redux/authSlice';
import ErrorFallback from './components/ErrorFallback';
var SUPPORTED_LANGUAGES = ['en', 'es'];
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.withCredentials = true;
window.onunload = function () {
    localStorage.removeItem('currScreen');
    localStorage.removeItem('goToLocationData');
    localStorage.removeItem('pickRunItemId');
    localStorage.removeItem('currentTotalPickRunItemQty');
    localStorage.removeItem('currIndexInPickRunDetailsArr');
    localStorage.removeItem('scannedContainerList');
    localStorage.removeItem('pickRunContainerList');
    localStorage.removeItem('pickRunId');
    localStorage.removeItem('cartId');
    localStorage.removeItem('containerId');
    localStorage.removeItem('containerIdStr');
    localStorage.removeItem('currIndexInPodDetailsList');
    localStorage.removeItem('scannedPodItemsList');
    localStorage.removeItem('scannedContainerIds');
    localStorage.removeItem('podsDetailsArray');
    localStorage.removeItem('currProdId');
    localStorage.removeItem('visitedPickRunItemQty');
    localStorage.removeItem('recommendedContainer');
    localStorage.removeItem('requiredPickContainerCount');
    localStorage.removeItem('currentPodLocationSeqId');
    localStorage.removeItem('currentWorkEffortId');
    localStorage.removeItem('workEffortIdsList');
    localStorage.removeItem('picklistContainerCounts');
    localStorage.removeItem('getContainerDetailsAPIStatus');
    localStorage.removeItem('fromLocation');
    localStorage.removeItem('toLocation');
    localStorage.removeItem('containerDetailNotification');
    localStorage.removeItem('pickedItemsArr');
    localStorage.removeItem('currentOrderId');
    localStorage.removeItem('orderContainerList');
    localStorage.removeItem('isConfirmDropoffAborted');
    localStorage.removeItem('packingStationContainers');
    localStorage.removeItem('hospitalContainers');
    localStorage.removeItem('scannedOrderIds');
    localStorage.removeItem('newCartScannedId');
    localStorage.removeItem('completeLocationData');
    localStorage.removeItem('pickMoveLocationSeqId');
    localStorage.removeItem('itemsCountData');
};
function App() {
    var _a = useSelector(userSelector), userId = _a.userId, preferenceValue = _a.preferenceValue;
    var history = useHistory();
    var dispatch = useDispatch();
    useEffect(function () {
        window.addEventListener('beforeunload', handleBeforeUnload);
        return function () {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []); // eslint-disable-line
    useEffect(function () {
        if (userId) {
            dispatch(getPrefferedLanguage({
                userId: localStorage.getItem('userId')
            }));
        }
    }, [userId, dispatch]);
    useEffect(function () {
        var storedLanguage = preferenceValue;
        if (!storedLanguage)
            return;
        if (!SUPPORTED_LANGUAGES.includes(storedLanguage)) {
            i18n.changeLanguage('en');
        }
        else {
            i18n.changeLanguage(storedLanguage);
        }
    }, [preferenceValue]);
    var handleBeforeUnload = function (e) {
        if (!window.location.href.split('/')[3] ||
            window.location.href.split('/')[3] === 'login' ||
            window.location.href.split('/')[3] === 'receiving' ||
            window.location.href.split('/')[3] === 'moveAsset' ||
            window.location.href.split('/')[3] === 'pickMultis') {
            // do nothing
        }
        else {
            e.preventDefault();
            var message = 'Are you sure you want to leave? All provided data will be lost.';
            e.returnValue = message;
            return message;
        }
    };
    axios.interceptors.response.use(function (response) {
        return response;
    }, function (error) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        var originalRequest = error.config;
        var currUrl = originalRequest.url.split('/');
        currUrl = currUrl[currUrl.length - 1];
        // Capture all API errors to Sentry (except session token renewal)
        var shouldCaptureToSentry = !(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 &&
            (((_d = (_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.includes) === null || _d === void 0 ? void 0 : _d.call(_c, 'Session token does not match')) ||
                ((_h = (_g = (_f = (_e = error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g.includes) === null || _h === void 0 ? void 0 : _h.call(_g, 'Session token does not match')) ||
                ((_l = (_k = (_j = error.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.includes) === null || _l === void 0 ? void 0 : _l.call(_k, 'Session token required')) ||
                ((_q = (_p = (_o = (_m = error.response) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.errors) === null || _p === void 0 ? void 0 : _p.includes) === null || _q === void 0 ? void 0 : _q.call(_p, 'Session token required'))));
        if (shouldCaptureToSentry) {
            Sentry.captureException(error, {
                tags: {
                    errorType: 'api_error',
                    endpoint: (originalRequest === null || originalRequest === void 0 ? void 0 : originalRequest.url) || 'unknown',
                    statusCode: ((_s = (_r = error.response) === null || _r === void 0 ? void 0 : _r.status) === null || _s === void 0 ? void 0 : _s.toString()) || 'unknown',
                    errorCategory: currUrl || 'unknown',
                },
                contexts: {
                    response: {
                        status: (_t = error.response) === null || _t === void 0 ? void 0 : _t.status,
                        statusText: (_u = error.response) === null || _u === void 0 ? void 0 : _u.statusText,
                        data: (_v = error.response) === null || _v === void 0 ? void 0 : _v.data,
                    },
                    request: {
                        url: originalRequest === null || originalRequest === void 0 ? void 0 : originalRequest.url,
                        method: originalRequest === null || originalRequest === void 0 ? void 0 : originalRequest.method,
                    },
                },
            });
            // Add to errorStore for badge notification
            errorStore.addError(error, 'high');
        }
        // Handle specific error cases
        if (currUrl.includes('lookupPickRun') && error.response.status === 400) {
            // Ignore error notification but return to prevent further processing
            return;
        }
        else if (currUrl === 'facility' && error.response.status === 400) {
            localStorage.clear();
            history.push('/login');
        }
        else if (error.response && error.response.status === 401) {
            var errorMsg = '';
            if (typeof error.response.data === 'string') {
                errorMsg = error.response.data;
            }
            else if (error.response.data.errors) {
                errorMsg = error.response.data.errors;
            }
            if (errorMsg.includes('Session token does not match') ||
                errorMsg.includes('Session token required')) {
                // Renew session token
                return axios.get('/rest/s1/fp/moquiSessionToken').then(function (resp) {
                    if (resp.status === 200) {
                        localStorage.setItem('moquiSessionToken', resp.data.moquiSessionToken);
                        originalRequest.headers['moquiSessionToken'] = resp.data.moquiSessionToken;
                        return axios(originalRequest);
                    }
                });
            }
            else if (errorMsg.includes('User must be logged in')) {
                localStorage.clear();
                history.push('/login');
            }
        }
        else if (error.response && error.response.status === 403) {
            var errorMsg = '';
            if (typeof error.response.data === 'string') {
                errorMsg = error.response.data;
            }
            else if (error.response.data.errors) {
                errorMsg = error.response.data.errors;
            }
            if (errorMsg.includes('is not authorized for View')) {
                localStorage.clear();
                window.location.replace('/#/login');
            }
        }
        else if (error.message === 'Network Error') {
            notification['error']({
                message: 'Error',
                description: 'Network Error'
            });
            return;
        }
        else if (error.response && error.response.data && error.response.data.errorCode === 400) {
            var capturedError = "Container " + currUrl + " is empty";
            var errMsg = '';
            if (typeof error.response.data === 'string') {
                errMsg = error.response.data;
            }
            else if (error.response.data.errors) {
                errMsg = error.response.data.errors;
            }
            if (errMsg.includes(capturedError)) {
                localStorage.setItem('getContainerDetailsAPIStatus', 'status_400');
            }
            else if (errMsg.includes('Cannot set preference with key ACTIVE_ORGANIZATION')) {
                notification['error']({
                    message: 'Error',
                    description: errMsg
                });
                localStorage.clear();
                window.location.replace('/#/login');
            }
            else {
                var containerDetailNotificationDisable = localStorage.getItem('containerDetailNotification');
                containerDetailNotificationDisable = JSON.parse(containerDetailNotificationDisable);
                if (!containerDetailNotificationDisable ||
                    errMsg.includes('No items is available for pick') ||
                    errMsg.includes('No item is available for pick')) {
                    notification['error']({
                        message: 'Error',
                        description: errMsg
                    });
                    if (errMsg.includes('No item is available for pick') ||
                        errMsg.includes('No items is available for pick')) {
                        setTimeout(function () {
                            window.location.replace('/');
                        }, 1500);
                    }
                }
            }
            return;
        }
        else {
            var errMsg = error.response && error.response.data && error.response.data.errors
                ? error.response.data.errors
                : 'Connection Refused';
            errorStore.addError(error, 'high');
            notification['error']({
                message: 'Error',
                description: errMsg
            });
            return;
        }
    });
    return (_jsx(Sentry.ErrorBoundary, __assign({ fallback: function (errorData) {
            errorStore.addError(errorData.error, 'high');
            return _jsx(ErrorFallback, __assign({}, errorData), void 0);
        }, showDialog: false }, { children: _jsx(Router, { children: _jsxs(Switch, { children: [_jsx(Route, { path: '/moveAsset', component: MoveAssetScreen }, void 0), _jsx(Route, { path: '/pickMultis', component: PickMultisScreen }, void 0), _jsx(Route, { path: '/pickSingle', render: function (props) { return _jsx(PickSingleScreen, __assign({}, props), void 0); } }, void 0), _jsx(Route, { path: '/sorting', component: SortingScreen }, void 0), _jsx(Route, { path: '/login', component: LoginScreen }, void 0), _jsx(Route, { path: '/receiving', component: ReceivingScreen }, void 0), _jsx(Route, { path: '/return', component: ReturnScreen }, void 0), _jsx(Route, { path: '/moveToSorting', component: MoveToSortingScreen }, void 0), _jsx(Route, { path: '/settings', component: SettingScreen }, void 0), _jsx(Route, { path: '/picking', component: PickRunsScreen }, void 0), _jsx(Route, { path: '/pickShipment', component: PickByShipmentScreen }, void 0), _jsx(Route, { path: '/packing', component: PackingScreen }, void 0), _jsx(Route, { path: '/putaway', component: PutAwayScreen }, void 0), _jsx(Route, { exact: true, path: '/', component: TaskSelectScreen }, void 0)] }, void 0) }, void 0) }), void 0));
}
export default App;
